export default {
  'base.resetPassword.title': 'Reset Password',
  'base.resetPassword.subtitle': 'Set a new login password',
  'base.resetPassword.invalidToken': 'Invalid reset link',
  'base.resetPassword.passwordMin': 'Password must be at least 6 characters',
  'base.resetPassword.mismatch': 'The two passwords do not match',
  'base.resetPassword.success': 'Password reset, please sign in again',
  'base.resetPassword.failed': 'Reset failed',
  'base.resetPassword.newLabel': 'New password',
  'base.resetPassword.newRequired': 'Please enter new password',
  'base.resetPassword.minPlaceholder': 'At least 6 characters',
  'base.resetPassword.confirmLabel': 'Confirm new password',
  'base.resetPassword.confirmPlaceholder': 'Enter new password again',
  'base.resetPassword.confirmRequired': 'Please enter the new password again',
}
